




























import { Component, mixins } from '@niknevis/vue-modules'
import { numberPresetNameMap, NumberPresetTypes } from '@/modules/common/filter/filter'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import InputRange from '@/modules/shared/components/shared/kit/InputRange.vue'

@Component({
  components: {
    BaseSelect,
    InputRange
  }
})
export default class NumericRange extends mixins(FilterComponentsMixin) {
  private get hasPreset() {
    return !!this.filter.presets && this.filter.presets.length > 0
  }

  private get presetOptions() {
    if (this.hasPreset) {
      return this.filter
        .presets
        ?.map(
          (preset) => typeof preset === 'string'
            ? {
              label: numberPresetNameMap[preset],
              value: preset
            }
            : {
              value: preset,
              label: preset.label
            }
        )
    }
    return []
  }

  private selectedPreset: {
    label: string
    value: NumberPresetTypes
  } | null = null

  private get range() {
    return {
      min: this.from,
      max: this.to
    }
  }

  private set range(value) {
    this.from = value.min
    this.to = value.max
  }

  private get showField() {
    return this.selectedPreset
      && (this.showGt || this.showLt)
  }

  // Upper boundary
  private get showLt() {
    switch (this.selectedPreset?.value) {
      case NumberPresetTypes.lessThan:
      case NumberPresetTypes.range:
      case NumberPresetTypes.equals:
        return true
      default:
        return false
    }
  }

  // Lower boundary
  private get showGt() {
    switch (this.selectedPreset?.value) {
      case NumberPresetTypes.greaterThan:
      case NumberPresetTypes.range:
        return true
      default:
        return false
    }
  }

  private get showLabel() {
    return this.selectedPreset?.value === NumberPresetTypes.range
  }

  private get isRange() {
    return this.selectedPreset?.value === NumberPresetTypes.range
  }

  checkForEquals() {
    if (this.selectedPreset?.value === NumberPresetTypes.equals) {
      this.from = this.to
    }
  }

  presetSelect() {
    switch (this.selectedPreset?.value) {
      case NumberPresetTypes.lessThan:
        this.to = this.to
        this.from = null
        break
      case NumberPresetTypes.greaterThan:
        this.from = this.from
        this.to = null
        break
      case NumberPresetTypes.equals:
        this.from = this.to = null
        break
      default:
        if (typeof this.selectedPreset?.value === 'object') {
          const customPreset = this.selectedPreset.value as any
          this.to = customPreset.to
          this.from = customPreset.from
        }
        break
    }
  }

  protected onReset() {
    this.selectedPreset = null
  }

  generatePresetOption(presetType: NumberPresetTypes): NumericRange['selectedPreset'] {
    return {
      value: presetType,
      label: numberPresetNameMap[presetType]
    }
  }

  mounted() {
    // Decide preset
    if (this.from && this.to && this.from === this.to) {
      if (this.from === this.to) {
        this.selectedPreset = this.generatePresetOption(NumberPresetTypes.equals)
      } else {
        this.selectedPreset = this.generatePresetOption(NumberPresetTypes.range)
      }
    } else if (this.from) {
      this.selectedPreset = this.generatePresetOption(NumberPresetTypes.greaterThan)
    } else if (this.to) {
      this.selectedPreset = this.generatePresetOption(NumberPresetTypes.lessThan)
    }
  }
}
